module.exports = __webpack_public_path__ + "img/fruit-bananas-350x184.ae3412ef.jpg";